import { render, staticRenderFns } from "./ApplicationSection.vue?vue&type=template&id=23525568&scoped=true&"
import script from "./ApplicationSection.vue?vue&type=script&lang=js&"
export * from "./ApplicationSection.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSection.vue?vue&type=style&index=0&id=23525568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23525568",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VRow})
